<div class="ft-navbar" [class.gradient]="gradient">
    <a (click)="hamburgerToggle()" class="hamburger-button" [class.d-lg-none]="hideHamburgerOnLg">
        <fa-icon [icon]="['fas', 'bars']"></fa-icon>
    </a>
    <div class="title" [class.d-none]="hideTitleOnXs" [class.d-lg-block]="hideTitleOnXs">{{ title }}</div>
    <div class="navbar-actions">
        <ng-content select="[navbarActions]"></ng-content>
        <a (click)="back()" class="back-button">
            <fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
        </a>
    </div>
</div>
